// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"d5efc035","425":"6caaf81c","510":"14ba4fb9","532":"414d80e7","633":"cc6f6079","634":"b9b217b9","922":"8fdc47f8","937":"e20eedc2","972":"e59d1e3f"}[chunkId] + ".chunk.js";
};